import IconButton from "components/foundation/IconButton";
import styled from "styled-components";

export const Wrap = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const OpenButton = styled(IconButton)`
  &,
  svg {
    width: 2.4rem;
    height: 2.4rem;
  }

  svg {
    color: ${({ theme }) => theme.color.grey[900]};
  }
`;
